<div class="bg-colour-grayscale-100 pb-5">
  <div class="overflow-hidden bg-colour-blue-700 text-white px-5">
    <div class="container d-flex my-4">
      <h1
        cover
        class="flex-fill display-5"
      >
        Firm details
      </h1>
    </div>
  </div>
  <div class="position-relative">
    <div
      class="position-absolute top-0 w-100 bg-colour-blue-700 text-white"
      [style.height]="'150px'"
    >
    </div>
    <div class="position-relative">
      <div class="container">
        <div class="d-flex flex-column gap-4">
          <div class="card border px-3 pt-1">
            <lib-firm-details
              (save)="router.navigateByUrl('/')"
              (requestForbidden)="location.back()"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
